import { combineReducers } from "redux"
import authReducer from "./auth/reducer"
import userReducer from "./user/reducers"
import schoolReducer from "./school/reducers"
import landingReducer from "./landing/reducer"
import coursesReducer from "./courses/reducer"

const rootReducer = combineReducers({
  authReducer,
  userReducer,
  schoolReducer,
  landingReducer,
  coursesReducer,
})

export default rootReducer
